import _ from 'lodash';
import { FileBlockOptions } from 'pages/documents_v2/views/edit_area/blocks/block_types/FileBlockOptions';
import HelperFunctions from 'pages/global/HelperFunctions';
import MediaSelector, { getFileUri, isValidUri } from 'pages/media_library/views/MediaSelector';

export function FileBlock({ block }) {
    const blockContent = block.latestContent || block.baseContent || '';
    const file = HelperFunctions.tryParseJSON(blockContent, null);

    return (
        <div className="p-4">
            <FileMedia file={file} />
        </div>
    );
}

function FileMedia({ file }) {
    const fileUri = getFileUri(_.get(file, 'uri', ''));
    const hasMedia = isValidUri(fileUri);

    return (
        <div className="d-flex">
            <MediaSelector selectedValue={fileUri} readOnly={true} />
            {hasMedia && <FileBlockOptions file={file} />}
        </div>
    );
}
